import axios from "axios";
import { toast } from "react-toastify";
import store from "../redux/store";
import { authLogout } from "../redux/auth/actions";
import { trackError } from "../utils/tracker";
import { SESSION_EXPIRATION_TIME, SESSION_EXPIRED_ERROR } from "../constants";

import { NetworkErrorToast } from "components/common";

const NETWORK_ERROR_TOAST_ID = "network-error";

const errorInterceptor = (error) => {
  if (axios.isCancel(error)) {
    return Promise.reject(error);
  }

  if (
    !window.navigator.onLine &&
    error.message === "Network Error" &&
    !error.code
  ) {
    if (!toast.isActive(NETWORK_ERROR_TOAST_ID)) {
      toast.error(<NetworkErrorToast />, { toastId: NETWORK_ERROR_TOAST_ID });
    }
    return;
  }

  const customAttributes = {};
  try {
    if (axios.isAxiosError(error)) {
      const { config } = error.response;

      const dataParsed = config?.data && JSON.parse(config?.data);

      const username = dataParsed?.username || dataParsed?.email;

      customAttributes.username = username;
      customAttributes.apiMethod = config?.method;
      customAttributes.apiBaseUrl = config?.baseURL;
      customAttributes.apiUrl = config?.url;
      customAttributes.errorResponseData =
        error.response?.data && JSON.stringify(error.response?.data);
    }
  } catch (interceptorErrorResponse) {
    trackError(interceptorErrorResponse, {
      interceptorErrorResponse: "true",
    });
  }

  trackError(error, customAttributes);

  return Promise.reject(error);
};

const unauthorizedInterceptor = (error) => {
  if (axios.isCancel(error)) {
    return Promise.reject(error);
  }

  if (error.response?.status === 401) {
    store.dispatch(authLogout(true));
  }

  return Promise.reject(error);
};

const sessionInterceptor = (req) => {
  const ttl = localStorage.getItem("ttl");

  if (ttl && Date.now() - ttl > SESSION_EXPIRATION_TIME) {
    store.dispatch(authLogout(true));

    return Promise.reject(new Error(SESSION_EXPIRED_ERROR));
  }

  if (ttl) {
    localStorage.setItem("ttl", Date.now());
  }

  return req;
};

export { errorInterceptor, unauthorizedInterceptor, sessionInterceptor };
